/**
 * Converts a CSS rem value to pixels.
 * @param {string} rem - The rem value to convert.
 * @param {number} [baseSize=16] - The base font size in pixels. Defaults to 16.
 * @returns {number} The pixel equivalent of the rem value.
 */
export const remToPixels = (rem: string, baseSize: number = 16): number => {
    if (!rem) return 0;
    const numericValue = Number(rem.replace('rem', ''));

    return baseSize * numericValue;
};
